import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {environment} from '../../../environments/environment';
import {TranslationListResponse, TranslationModel, TranslationResponse} from '../translation.models';
import {Helper} from '../../helpers/helper.service';



@Injectable()
export class TranslationService {
  /**
   * @param helper
   * @param {HttpClient} http
   */
  constructor(private helper: Helper, private http: HttpClient) {}

  /**
   * List translations in a language
   *
   * @returns {Observable<TranslationListResponse>}
   * @param params
   */
  list(
    params: HttpParams,
  ): Observable<TranslationListResponse> {
    const url = `${environment.apiUrl}/translation/translation/`;
    const not_translatedIndex = params['updates'].findIndex((item: any) => item.param === 'q[not_translated]');
    if (not_translatedIndex !== -1) {
      if (!params['updates'][not_translatedIndex].value) {
        params['updates'].splice(not_translatedIndex, 1);
      }
    }
  return this.http.get<TranslationListResponse>(
      url,
      {params: params}
    );
  }

  /**
   * Update a translation
   *
   * @param {number} language_id
   * @param {TranslationModel} translation
   * @returns {Observable<TranslationResponse>}
   */
  update(
    language_id: number,
    translation: TranslationModel
  ): Observable<TranslationResponse> {
    const url = `${environment.apiUrl}/translation/translation/language/${language_id}/unit/${translation.id}`;
    return this.http.put<TranslationResponse>(
      url,
      {value: translation.value}
    );
  }

  /**
   * List a translation in all languages
   *
   * @param {TranslationModel} translation
   * @returns {Observable<TranslationListResponse>}
   */
  listAll(translation: TranslationModel): Observable<TranslationListResponse> {
    const url = `${environment.apiUrl}/translation/translation/unit/${translation.id}`;
    return this.http.get<TranslationListResponse>(url);
  }

  /**
   * Update a translation in all languages
   *
   * @param {TranslationModel} translation
   * @param {TranslationModel[]} translations
   * @returns {Observable<TranslationListResponse>}
   */
  updateAll(translation: TranslationModel, translations: TranslationModel[]): Observable<TranslationListResponse> {
    const url = `${environment.apiUrl}/translation/translation/unit/${translation.id}`;
    return this.http.put<TranslationListResponse>(
      url,
      {translations: translations}
    );
  }
}
